import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
import { PlanillaPartidoOficialMesaNoRegsitradoAssertions } from '../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitradoAssertions';
class PlanillaPartidoOficialMesaNoRegsitradoForm extends CustomForm {
  protected constructor(
    ppomnr_id: string | null,
    ppomnr_ppid: string,
    ppomnr_eqid: number,
    ppomnr_nombre: string,
    ppomnr_apellido: string,
    ppomnr_dni: string
  ) {
    const pla = PlanillaPartidoOficialMesaNoRegsitradoAssertions.build();
    super('PlanillaPartidoOficialMesaNoRegsitrado', pla);
    this.addInputAsserted('ppomnr_id', ppomnr_id);
    this.addInputAsserted('ppomnr_ppid', ppomnr_ppid);
    this.addInputAsserted('ppomnr_eqid', ppomnr_eqid);
    this.addInput('ppomnr_nombre', ppomnr_nombre);
    this.addInput('ppomnr_apellido', ppomnr_apellido);
    this.addInput('ppomnr_dni', ppomnr_dni);
  }

  private static build(
    ppomnr_id: string | null,
    ppomnr_ppid: string,
    ppomnr_eqid: number,
    ppomnr_nombre: string,
    ppomnr_apellido: string,
    ppomnr_dni: string
  ) {
    return new this(ppomnr_id, ppomnr_ppid, ppomnr_eqid, ppomnr_nombre, ppomnr_apellido, ppomnr_dni);
  }

  static initialize() {
    return this.build(null, '', 1, '', '', '');
  }

  static with(
    ppomnr_id: string | null,
    ppomnr_ppid: string,
    ppomnr_eqid: number,
    ppomnr_nombre: string,
    ppomnr_apellido: string,
    ppomnr_dni: string
  ) {
    return this.build(ppomnr_id, ppomnr_ppid, ppomnr_eqid, ppomnr_nombre, ppomnr_apellido, ppomnr_dni);
  }

  getIdInput() {
    return this.getInputByName('ppomnr_id');
  }

  getPpidInput() {
    return this.getInputByName('ppomnr_ppid');
  }

  getEqidInput() {
    return this.getInputByName('ppomnr_eqid');
  }

  getNombreInput() {
    return this.getInputByName('ppomnr_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('ppomnr_apellido');
  }

  getDniInput() {
    return this.getInputByName('ppomnr_dni');
  }

  // toPlanillaPartidoOficialMesaNoRegsitrado(): PlanillaPartidoOficialMesaNoRegsitrado {
  //     return PlanillaPartidoOficialMesaNoRegsitrado.createFrom(
  //     this.getIdInput().getValue(),
  //     this.getPpidInput().getValue(),
  //     this.getEqidInput().getValue(),
  //     this.getNombreInput().getValue(),
  //     this.getApellidoInput().getValue(),
  //     this.getDniInput().getValue())
  // }
}

export default PlanillaPartidoOficialMesaNoRegsitradoForm;
